import { connect } from 'react-redux';
import { showSurveyNotesModal } from 'actions/internal';
import { getWebNotesCount, getDashboardQuery, getNotesQuestionnaireId } from 'selectors';
import PlayerHeader from 'components/player/PlayerHeader';

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
    locationFrom: ownProps.locationFrom,
    player: state.player.player,
    playerQuestionnaireId: getNotesQuestionnaireId(state),
    search: getDashboardQuery(state.meta.surveys),
    webNotesCount: getWebNotesCount(state.player.survey),
  }
}

const PlayerHeaderContainer = connect(
  mapStateToProps,
  { showSurveyNotesModal }
)(PlayerHeader)

export default PlayerHeaderContainer;
